import styled from 'styled-components';
import * as grid from 'view/styles/grid';
import * as mixins from 'view/styles/mixins';
import { token } from '@atlaskit/tokens';

export const ButtonGroup = styled.div`
    ${mixins.flexCenter};
    margin-top: ${token('space.200', '16px')};
    justify-content: flex-start;

    > * {
        margin-right: ${token('space.100', '8px')};
    }
`;

export const Root = styled.div`
    position: relative;
    /* We're setting min height here so when the spinner is loaded it is displayed
    in at least something that is 50 grid units high. */
    min-height: ${grid.multiple(50).px};
`;
